<script>
  import {Line} from 'vue-chartjs'

  export default {
    extends: Line,
    props: ['height', 'data', 'showYAxis'],
    data: function () {
      const self = this
      const showYAxis = !!this.showYAxis
      return {
        tooltipEl: null,
        options: {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
            enabled: false,
            displayColors: false,
            custom: function (tooltipModel) {
              self.renderExternalTooltip(this._chart, tooltipModel)
            },
            callbacks: {
              title: function (tooltipItems, data) {
                if (!tooltipItems || tooltipItems.length === 0) return ''
                const idx = tooltipItems[0].index
                return data && data.labels && data.labels[idx] ? data.labels[idx] : ''
              },
              label: function (tooltipItem) {
                return 'Players: ' + tooltipItem.yLabel
              }
            }
          },
          layout: {
            padding: {
              left: 4,
              right: 4,
              bottom: 2,
              top: 2
            }
          },
          scales: {
            xAxes: [{
              display: true,
              gridLines: {
                display: true,
                drawBorder: false,
                borderDash: [2, 3],
                color: 'rgba(185, 194, 203, 0.12)',
                zeroLineColor: 'rgba(185, 194, 203, 0.08)',
                zeroLineBorderDash: [2, 3]
              },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 16,
                fontSize: 11,
                fontColor: '#b9c2cb',
                maxRotation: 0,
                minRotation: 0,
                callback: function (label) {
                  if (!label || typeof label !== 'string') return ''
                  // label format: YYYY-MM-DD HH:mm
                  const parts = label.split(' ')
                  if (parts.length < 2) return label
                  const dateParts = parts[0].split('-')
                  const time = parts[1]
                  if (dateParts.length !== 3) return label
                  const y = parseInt(dateParts[0], 10)
                  const m = parseInt(dateParts[1], 10) - 1
                  const d = parseInt(dateParts[2], 10)
                  const dt = new Date(y, m, d)
                  if (time === '00:00' || time === '00:00:00') {
                    const pad = n => n.toString().padStart(2, '0')
                    return `${pad(d)}.${pad(m + 1)}`
                  }
                  const days = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
                  return days[dt.getDay()] + ' ' + time
                }
              }
            }],
            yAxes: [{
              display: showYAxis,
              gridLines: {
                display: showYAxis,
                drawBorder: false,
                color: 'rgba(185, 194, 203, 0.12)'
              },
              ticks: {
                display: showYAxis,
                fontSize: 9,
                fontColor: '#9fb0ba',
                beginAtZero: true,
                maxTicksLimit: 4
              }
            }]
          },
          elements: {
            line: {
              borderWidth: 2,
              tension: 0.35
            },
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4
            }
          }
        }
      }
    },
    mounted () {
      this.renderChart(this.data, this.options)
    },
    watch: {
      data: {
        deep: true,
        handler () {
          this.renderChart(this.data, this.options)
        }
      }
    },
    beforeDestroy () {
      if (this.tooltipEl && this.tooltipEl.parentNode) {
        this.tooltipEl.parentNode.removeChild(this.tooltipEl)
        this.tooltipEl = null
      }
    },
    methods: {
      update () {
        this.$data._chart.update()
      },
      renderExternalTooltip (chart, tooltipModel) {
        if (!chart) return
        if (!this.tooltipEl) {
          const el = document.createElement('div')
          el.className = 'chartjs-external-tooltip'
          el.style.opacity = 0
          document.body.appendChild(el)
          this.tooltipEl = el
        }

        const tooltipEl = this.tooltipEl
        if (tooltipModel.opacity === 0) {
          tooltipEl.style.opacity = 0
          return
        }

        const titleLines = tooltipModel.title || []
        const bodyLines = tooltipModel.body ? tooltipModel.body.map(b => b.lines) : []
        const titleHtml = titleLines.map(line => `<div class="tooltip-title">${line}</div>`).join('')
        const bodyHtml = bodyLines.map(line => `<div class="tooltip-body">${line}</div>`).join('')
        tooltipEl.innerHTML = `${titleHtml}${bodyHtml}`

        const position = chart.canvas.getBoundingClientRect()
        const left = position.left + window.pageXOffset + tooltipModel.caretX
        const top = position.top + window.pageYOffset + tooltipModel.caretY

        tooltipEl.style.opacity = 1
        tooltipEl.style.left = `${left}px`
        tooltipEl.style.top = `${top - 8}px`
        tooltipEl.style.transform = 'translate(-50%, -100%)'
      }
    }
  }
</script>

<style>
.chartjs-external-tooltip {
  position: absolute;
  pointer-events: none;
  background: rgba(19, 24, 28, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #e6f0f2;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 0.72rem;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
  z-index: 10000;
  white-space: nowrap;
}

.chartjs-external-tooltip .tooltip-title {
  font-weight: 700;
  color: #b7c7d1;
  margin-bottom: 2px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 0.62rem;
}
</style>
